export const LAST_ACTIVITY_TIME = 'lastActivityTime'
